export default __webpack_public_path__ + "static/media/kh.7b33804c.svg";